import { z } from "zod";
import {
  ALLOWED_CHARS_REGEX,
  ALLOWED_SPECIAL_CHARS,
} from "../../utils/password-validator";

export const PASSWORD_MIN_LENGTH = 8;

export const userCardSecuritySchema = z
  .object({
    currentPassword: z.string().min(1, "Current password is required"),
    newPassword: z
      .string()
      .min(PASSWORD_MIN_LENGTH, "Minimum 8 characters")
      .regex(/[A-Z]/, "At least 1 uppercase letter")
      .regex(/[a-z]/, "At least 1 lowercase letter")
      .regex(/\d/, "At least 1 number")
      .refine(
        (val) =>
          val.split("").some((char) => ALLOWED_SPECIAL_CHARS.includes(char)),
        "At least 1 special character"
      )
      .refine(
        (val) => ALLOWED_CHARS_REGEX.test(val),
        `Only letters, numbers, and ${ALLOWED_SPECIAL_CHARS.split("").join(" ")} are allowed, including as the last character`
      ),
    confirmNewPassword: z.string().min(1, "Please confirm your new password"),
  })
  .refine((data) => data.newPassword === data.confirmNewPassword, {
    message: "Password don't match\nWrite them carefully",
    path: ["confirmNewPassword"],
  });

export type PasswordFormData = z.infer<typeof userCardSecuritySchema>;
